export default "__VITE_PUBLIC_ASSET__87f8917e__"